import React from 'react';

function TermsOfService() {
  return (
    <div style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '2rem',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
    }}>
      <h1 style={{ 
        fontSize: '2.5rem', 
        marginBottom: '2rem', 
        color: '#212529',
        textAlign: 'center'
      }}>Terms of Service</h1>
      
      <div style={{ color: '#212529', lineHeight: '1.6' }}>
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>1. Acceptance of Terms</h2>
          <p>By using Pre Go Prep, you acknowledge that you have read, understood, and agreed to these Terms of Service, as well as our Privacy Policy.</p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>2. Use of Services</h2>
          <p>Pre Go Prep provides tools and resources to assist users in estimating performance timing and therapeutic application scheduling. These tools are for informational purposes only and should not be solely relied upon for competition planning or scheduling.</p>
          <ul style={{ marginLeft: '2rem', marginTop: '1rem' }}>
            <li>You agree to use Pre Go Prep only for its intended purposes and in compliance with all applicable laws.</li>
            <li>You must not attempt to disrupt, hack, or otherwise interfere with our website or services.</li>
            <li>We reserve the right to suspend or terminate access to users who violate these terms.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>3. No Warranty & Limitation of Liability</h2>
          <ul style={{ marginLeft: '2rem' }}>
            <li>Pre Go Prep provides estimates and calculations based on user input and general formulas. We do not guarantee the accuracy, reliability, or completeness of any provided information.</li>
            <li>We are not responsible for any missed performance times, miscalculations, or other consequences resulting from the use of our tools.</li>
            <li>Pre Go Prep shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the service.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>4. User Responsibilities</h2>
          <ul style={{ marginLeft: '2rem' }}>
            <li>You are responsible for verifying all event details, start times, and scheduling factors with the official event producer.</li>
            <li>You agree not to misuse or misrepresent the results provided by Pre Go Prep.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>5. Modifications to the Service</h2>
          <p>We may update, modify, or discontinue any part of our website, tools, or services at any time without prior notice.</p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>6. Intellectual Property</h2>
          <p>All content, branding, and tools on Pre Go Prep are owned by us and protected under intellectual property laws. You may not copy, modify, or distribute our content without permission.</p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>7. Privacy & Data Collection</h2>
          <p>Our use of data is governed by our Privacy Policy. By using Pre Go Prep, you consent to our data collection and usage practices as outlined there.</p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>8. Governing Law & Dispute Resolution</h2>
          <p>These Terms shall be governed by the laws of Washington state. Any disputes arising under these terms shall be resolved through binding arbitration or in the courts of Washington.</p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>9. Contact Information</h2>
          <p>
            If you have any questions about these Terms of Service, please visit our{' '}
            <a href="/about-contact" style={{ color: '1e40af', textDecoration: 'underline' }}>
              About &amp; Contact
            </a>{' '}
            page for ways to reach us.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>10. SMS Terms</h2>

          <p>
            By opting in to receive SMS reminders from Pre Go Prep, you agree to the following:
          </p>

          <h3 style={{ fontSize: '1.2rem', marginTop: '1rem', marginBottom: '0.5rem', color: '#111827' }}>
            Consent
          </h3>
          <p>
            By providing your mobile phone number and checking the SMS opt-in box, you provide your express written
            consent to receive automated text messages from Pre Go Prep related to race day preparation, including
            estimated performance go times or therapeutic timing-related reminders.
          </p>
          <p>
            Consent to receive SMS messages is not a condition of purchase.
          </p>

          <h3 style={{ fontSize: '1.2rem', marginTop: '1rem', marginBottom: '0.5rem', color: '#111827' }}>
            Message Frequency
          </h3>
          <p>
            Message frequency may vary based on your saved horses, race schedules, and notification preferences.
          </p>

          <h3 style={{ fontSize: '1.2rem', marginTop: '1rem', marginBottom: '0.5rem', color: '#111827' }}>
            Costs
          </h3>
          <p>
            Message and data rates may apply. Pre Go Prep is not responsible for charges imposed by your mobile carrier.
          </p>

          <h3 style={{ fontSize: '1.2rem', marginTop: '1rem', marginBottom: '0.5rem', color: '#111827' }}>
            Opt-Out &amp; Help
          </h3>
          <p>
            You may opt out at any time by replying STOP to any message. You may reply HELP for assistance.
          </p>

          <h3 style={{ fontSize: '1.2rem', marginTop: '1rem', marginBottom: '0.5rem', color: '#111827' }}>
            Delivery Disclaimer
          </h3>
          <p>
            Message delivery is not guaranteed and may be delayed or fail due to factors outside our control, including
            carrier restrictions or network conditions.
          </p>

          <h3 style={{ fontSize: '1.2rem', marginTop: '1rem', marginBottom: '0.5rem', color: '#111827' }}>
            Changes
          </h3>
          <p>
            Pre Go Prep reserves the right to modify or discontinue SMS messaging at any time.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>11. Subscription Billing</h2>

          <p>
            Some features of Pre Go Prep require a paid
            subscription. By subscribing, you authorize recurring charges to your payment method at the subscription
            price shown at checkout. You will be charged at the start of each billing period (e.g. monthly).
          </p>
          <p>
            You may cancel at any time. Cancellation stops future charges, and you keep access until the end of the current billing
            period. We will notify you before any price change and allow you to cancel. If you start a free trial, you will not be charged until the trial ends unless you cancel before then.
          </p>

          <h3 style={{ fontSize: '1.2rem', marginTop: '1rem', marginBottom: '0.5rem', color: '#111827' }}>
            Free Trial
          </h3>
          <p>
            When you start a free trial, you will not be charged until the trial period ends. Unless you cancel before
            the trial ends, your subscription will automatically begin and your payment method will be charged at the
            then-current subscription price.
          </p>

          <h3 style={{ fontSize: '1.2rem', marginTop: '1rem', marginBottom: '0.5rem', color: '#111827' }}>
            Billing Cycle
          </h3>
          <p>
            Subscriptions are billed monthly unless otherwise specified.
          </p>

          <h3 style={{ fontSize: '1.2rem', marginTop: '1rem', marginBottom: '0.5rem', color: '#111827' }}>
            Cancellation
          </h3>
          <p>
            You may cancel your subscription at any time through the subscription or billing management page linked in
            your Profile. Cancellation will take effect at the end of the current billing period.
          </p>

          <h3 style={{ fontSize: '1.2rem', marginTop: '1rem', marginBottom: '0.5rem', color: '#111827' }}>
            Refunds
          </h3>
          <p>
            Subscriptions renew automatically each billing period unless canceled. You may cancel at any time, and
            cancellation will take effect at the end of the current billing period. We do not provide refunds for any
            subscription period once it has been charged.
          </p>

          <h3 style={{ fontSize: '1.2rem', marginTop: '1rem', marginBottom: '0.5rem', color: '#111827' }}>
            Payment Processing
          </h3>
          <p>
            Payment processing is handled by Stripe, Inc. By completing payment, you also agree to Stripe's terms.
            Pre Go Prep does not store your full payment card details on our servers; Stripe handles all card data in
            accordance with PCI-DSS standards.
          </p>

          <h3 style={{ fontSize: '1.2rem', marginTop: '1rem', marginBottom: '0.5rem', color: '#111827' }}>
            Failed Payments
          </h3>
          <p>
            If a renewal payment fails, we may attempt to retry the charge for a short grace period before suspending
            or canceling your paid features. You are responsible for keeping your payment method current through the
            billing management page.
          </p>
        </section>

        <div style={{
          marginTop: '3rem',
          padding: '1rem',
          backgroundColor: '#f8fafc',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <p style={{ marginBottom: '1rem' }}>
            By using Pre Go Prep, you acknowledge that you have read and agreed to these Terms of Service.
          </p>
          <p style={{ color: '#64748b' }}>
            Last Updated: May 1, 2026
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService; 